import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Moment from 'moment';
import ProjectThumb from '../partials-thumbnails/project-thumb';
import { FormattedMessage } from 'react-intl';


export class ProjectInfoBox extends Component {
  constructor (props) {
    super(props);

    this.infoBox = this.infoBox.bind(this);
  }

  infoBox () {
    const {
      project: {
        schedule,
        name,
        activity,
        location,
        count
      },
      CTA,
      hideEllipsis
    } = this.props;
    const date = schedule && schedule.length ? schedule[0].start.date : null;
    const formattedDate = date ? Moment({ month: date.m - 1, day: date.d, year: date.y }).format('ll') : null;
    const formattedSubheader = `${activity} ${formattedDate ? formattedDate : ''} ${location ? location : ''}`;

    return (
      <div className='project-thumb-container'>
        <h6 className='title ellipsis padding-md-top'>
          {name}
        </h6>
        <div className='project-activity-date'>
          <div
            className={`capitalize text-small ${
              hideEllipsis ? '' : 'ellipsis'
            }`}
            style={{ minHeight: '27px' }}
          >
            {formattedSubheader}
          </div>
        </div>
        <div className='flex space-between'>
          {count ? (
            <div className={`text-small text-gray`}>
              <FormattedMessage
                id='boards.project_info_box.invite_sent'
                defaultMessage='{count} {spaces}'
                values={{
                  count: count,
                  spaces:
                    1 < count ? (
                      <FormattedMessage
                        id='boards.project_info_box.spaces'
                        defaultMessage='spaces'
                      />
                    ) : (
                      <FormattedMessage
                        id='boards.project_info_box.space'
                        defaultMessage='space'
                      />
                    )
                }}
              />
            </div>
          ) : null}
          {CTA && <CTA />}
        </div>
      </div>
    );
  }

  render () {
    const {
      cover_img_id
    } = this.props.project;

    return (
      <ProjectThumb
        coverImageId={cover_img_id}
        ratio={1.689}
        widths={[512, 768]}
        alt={ "Peerspace" }
        infoBox={this.infoBox}
      />
    );
  }
}

ProjectInfoBox.defaultProps = {

}

ProjectInfoBox.propTypes = {
  useBootstrapGrid: PropTypes.bool
};